"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _APPagination = _interopRequireDefault(require("./APPagination.styles"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var APPagination = function APPagination(_ref) {
  var hasPrevious = _ref.hasPrevious,
    hasNext = _ref.hasNext,
    handlePrevious = _ref.handlePrevious,
    handleNext = _ref.handleNext,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'BOTH' : _ref$type,
    _ref$prevString = _ref.prevString,
    prevString = _ref$prevString === void 0 ? 'PREV' : _ref$prevString,
    _ref$nextString = _ref.nextString,
    nextString = _ref$nextString === void 0 ? 'NEXT' : _ref$nextString;
  var classes = (0, _APPagination["default"])();
  return /*#__PURE__*/_react["default"].createElement("div", null, type === 'PREV' || type === 'BOTH' ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: (0, _clsx["default"])(classes.root, !hasPrevious && classes.disabled),
    startIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      size: "6x",
      icon: _freeSolidSvgIcons.faCaretLeft
    }),
    onClick: handlePrevious,
    disabled: !hasPrevious
  }, prevString) : null, type === 'NEXT' || type === 'BOTH' ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: (0, _clsx["default"])(classes.root, !hasNext && classes.disabled),
    endIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faCaretRight
    }),
    onClick: handleNext,
    disabled: !hasNext
  }, nextString) : null);
};
var _default = APPagination;
exports["default"] = _default;